<template>
  <div class="t-error-page">
    <h1>{{ title }}</h1>

    <p>{{ friendly }} &#x2639;</p>

    <button type="button" @click="reload">Try again</button>

    <div v-if="message" class="t-error-detail">
      <h2>Detail</h2>
      <pre>{{ message }}</pre>
    </div>
  </div>
</template>

<style scoped lang="scss">
.t-error-page {
  padding: 20px;
}
.t-error-detail {
  margin-top: 60px;
  pre {
    white-space: pre-wrap;
  }
}
</style>

<script>
export default {
  name: 'ErrorPage',

  props: ['error'],

  data() {
    const e =
      typeof this.error === 'object'
        ? this.error
        : this.error
        ? {friendly: this.error}
        : {}
    return {
      title: 'Whoops',
      friendly: "Something's not working",
      message: null,
      ...e,
    }
  },

  methods: {
    reload() {
      window.location.reload()
    },
  },
}
</script>
